export default "__VITE_ASSET__Bdz9ACJL__"